<app-version-check-bar />
<div>
  <router-outlet></router-outlet>
</div>



